// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'magnet';

export const Component = () => (
  <path d='M22.594 1h-5.89v13.219c0 1.197-.432 2.25-1.294 3.113-.862.91-1.915 1.34-3.113 1.34s-2.25-.43-3.113-1.34c-.862-.862-1.293-1.916-1.293-3.113V1H2v13.219c0 2.826 1.005 5.268 3.017 7.28 2.012 2.011 4.454 3.017 7.28 3.017 2.826 0 5.268-1.006 7.28-3.018 2.011-2.011 3.017-4.453 3.017-7.28V1ZM2.958 3.922V1.959h3.927v1.963H2.958Zm18.678 1.005v9.292c0 2.586-.91 4.789-2.73 6.61-1.868 1.819-4.07 2.729-6.61 2.729-2.537 0-4.74-.91-6.56-2.73-1.868-1.82-2.778-4.023-2.778-6.61v-9.29h3.927v9.29c0 1.485.527 2.779 1.58 3.832 1.055 1.053 2.348 1.58 3.832 1.58s2.778-.526 3.831-1.58 1.58-2.347 1.58-3.831V4.927h3.928Zm0-2.97v1.964h-3.927V1.958h3.927Z' />
);

export const viewBox = '0 0 25 25';
